document.addEventListener("DOMContentLoaded", function () {
  // Load YouTube IFrame API
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.youtubePlayers = {};

  // --- Helper function to toggle mute icons ---
  const toggleIcons = (button, muted) => {
    if (!button) return;
    const muteIcon = button.querySelector(".icon-mute");
    const volumeIcon = button.querySelector(".icon-volume");
    muteIcon?.classList.toggle("hidden", !muted);
    volumeIcon?.classList.toggle("hidden", muted);
  };
  // --- End Helper ---

  window.onYouTubeIframeAPIReady = function () {
    document.querySelectorAll(".youtube-embed").forEach((container) => {
      let videoId = container.dataset.youtubeId;
      if (videoId) {
        const playerId = container.id;
        container.player = new YT.Player(container, {
          videoId: videoId,
          playerVars: {
            autoplay: 0,
            controls: 0,
            modestbranding: 1,
            rel: 0,
            mute: 1, // Start muted
            showInfo: 0,
            cc_load_policy: 0,
            iv_load_policy: 3,
            disablekb: 1,
            fs: 0,
            loop: 1,
            playlist: videoId,
          },
          events: {
            onReady: function (event) {
              window.youtubePlayers[playerId] = event.target;
              const slide = container.closest(".swiper-slide");
              if (slide) {
                const button = slide.querySelector(".mute-button");
                // Set icon based on actual player state once ready
                toggleIcons(button, event.target.isMuted());
              }
            },
          },
        });
      }
    });
  };

  // Initialize Swiper for each slider instance
  document.querySelectorAll(".product-videos-slider").forEach((sliderEl) => {
    const uniqueCount = parseInt(sliderEl.dataset.originalCount || "0", 10);
    const paginationEl = sliderEl.querySelector(".swiper-pagination");
    const nextEl = sliderEl.querySelector(".product-video-slider__button.next");
    const prevEl = sliderEl.querySelector(".product-video-slider__button.prev");

    new Swiper(sliderEl, {
      initialSlide: 0,
      slideToClickedSlide: true,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        360: { slidesPerView: 1, spaceBetween: 10, allowTouchMove: true },
        501: { slidesPerView: 3, spaceBetween: 30, allowTouchMove: false },
      },
      on: {
        init(swiperInstance) {
          setTimeout(() => {
            if (swiperInstance.slides.length > 1) {
              swiperInstance.slideTo(1, 0);
            }
            syncTripletPagination(swiperInstance, uniqueCount);
          }, 50);
          // --- EDIT: Update icons for ALL initially visible slides ---
          swiperInstance.slides.forEach((slide) => {
            const button = slide.querySelector(".mute-button");
            if (!button) return; // Skip if no button

            const html5Video = slide.querySelector("video");
            const youtubeEmbed = slide.querySelector(".youtube-embed");

            if (html5Video) {
              // HTML5 videos are muted via Liquid attribute initially
              toggleIcons(button, html5Video.muted);
            } else if (youtubeEmbed) {
              // Assume YouTube videos start muted based on playerVars.
              // The onReady handler will confirm/correct this later.
              const player = window.youtubePlayers?.[youtubeEmbed.id];
              if (player && typeof player.isMuted === "function") {
                // If player is already ready, use its state
                toggleIcons(button, player.isMuted());
              } else {
                // Otherwise, assume muted based on config
                toggleIcons(button, true);
              }
            }
          });
          // Play video in the initial active slide
          updateVideoPlayback(swiperInstance);
          syncTripletPagination(swiperInstance, uniqueCount);
          // --- END EDIT ---
        },
        slideChange(swiperInstance) {
          syncTripletPagination(swiperInstance, uniqueCount);
        },
        slideChangeTransitionEnd(swiperInstance) {
          updateVideoPlayback(swiperInstance);
          syncTripletPagination(swiperInstance, uniqueCount);
        },
      },
    });
  });

  function updateVideoPlayback(swiperInstance) {
    swiperInstance.slides.forEach((slide, index) => {
      let html5Video = slide.querySelector("video");
      let youtubeEmbed = slide.querySelector(".youtube-embed");
      let youtubePlayer = youtubeEmbed
        ? window.youtubePlayers[youtubeEmbed.id]
        : null;

      if (index === swiperInstance.activeIndex) {
        // Play video in active slide
        if (html5Video) {
          // Ensure it's muted before playing (matching initial state)
          html5Video.muted = true;
          html5Video
            .play()
            .catch((error) => console.log("Video play prevented:", error)); // Play and catch potential errors
          // Update icon state just in case it was changed while inactive
          const button = slide.querySelector(".mute-button");
          toggleIcons(button, html5Video.muted);
        }
        if (youtubePlayer && typeof youtubePlayer.playVideo === "function") {
          youtubePlayer.mute(); // Ensure muted
          youtubePlayer.playVideo();
          // Icon state should be correct from onReady or click handler
        }
      } else {
        // Pause video in inactive slides
        if (html5Video) {
          html5Video.pause();
        }
        if (youtubePlayer && typeof youtubePlayer.pauseVideo === "function") {
          youtubePlayer.pauseVideo();
        }
      }
    });
  }

  function syncTripletPagination(swiperInstance, uniqueCount) {
    if (uniqueCount !== 3) return;
    const bullets = swiperInstance.pagination?.bullets;
    if (!bullets || !bullets.length) return;

    const bulletList = Array.isArray(bullets) ? bullets : Array.from(bullets);

    const targetIndex = swiperInstance.realIndex % uniqueCount;

    bulletList.forEach((bullet, idx) => {
      if (idx >= uniqueCount) {
        bullet.style.display = "none";
        bullet.classList.remove("swiper-pagination-bullet-active");
        return;
      }

      bullet.style.display = "";
      bullet.classList.toggle("swiper-pagination-bullet-active", idx === targetIndex);
    });
  }

  if (!window.muteButtonListenerRegistered) {
    window.muteButtonListenerRegistered = true;

    document.addEventListener("click", function (e) {
      console.log("event target", e.target);
      const button = e.target.closest(".mute-button");
      if (!button) return;

      const wrapper = button.closest(".video-container");
      if (!wrapper) return;

      const html5Video = wrapper.querySelector("video");
      console.log("video mute button is clicked!", html5Video);
      const youtubeEmbed = wrapper.querySelector(".youtube-embed");
      // Removed muteIcon/volumeIcon variables, using toggleIcons helper

      if (html5Video) {
        html5Video.muted = !html5Video.muted;
        toggleIcons(button, html5Video.muted); // Use helper
      } else if (youtubeEmbed) {
        // Use the correct ID (container.id) to find the player
        const player = window.youtubePlayers?.[youtubeEmbed.id];
        if (!player || typeof player.isMuted !== "function") return; // Check if player and methods exist

        const isMuted = player.isMuted();
        if (isMuted) {
          player.unMute();
          toggleIcons(button, false); // Use helper
        } else {
          player.mute();
          toggleIcons(button, true); // Use helper
        }
      }
    });
  }
});
